import React, { useState } from 'react';
import { Pressable } from 'react-native';
import Hoverable from '../../util/Hoverable/Hoverable';
import DNAText from './DNAText';
const DNATextLink = (props) => {
    const { children, onPress, ...rest } = props;
    const [hovered, setIsHovered] = useState(false);
    const toggleHover = () => {
        setIsHovered((prev) => !prev);
    };
    return (<Hoverable onHoverIn={toggleHover} onHoverOut={toggleHover}>
      <Pressable onPress={onPress}>
        <DNAText {...rest} style={hovered && { textDecorationLine: 'underline' }}>
          {children}
        </DNAText>
      </Pressable>
    </Hoverable>);
};
export default DNATextLink;
//# sourceMappingURL=DNATextLink.js.map